import axios from 'axios';
import store from '../store';
import { projetoService } from '../../domain/projeto/ProjetoService';

// axios.interceptors.response.use(
//   function(response) { return response; },
//   function(error) {
//       if (error.response) {
//         console.log(error.response);
//         store.commit('showNotification', { text: error.response.data.error, status: 'error' });
//         return Promise.reject(error);
//       }
//   });

// const baseUrl = 'http://192.168.1.8:3000';
const baseUrl = process.env.VUE_APP_ROOT_API;

const getDefaultState = () => {
  return {
    projetos: [],
    projetosSelected: [],
    itensProjetos: [],
    atividadesProjeto: [],
    projetoColaboradores: [],
    projetoTags: [],
    projetosVinculo: []
  }
}

const state = getDefaultState();

const getters = {
  // Projeto
  projetos: state => state.projetos,
  projetosSelected: state => state.projetosSelected,
  getProjeto: state => id => state.projetos.find(projeto => projeto.IdProjeto === id),
  itensProjetos: state => state.itensProjetos,
  atividadesProjeto: state => state.atividadesProjeto,
  // Colaboradores
  projetoColaboradores: state => state.projetoColaboradores,
  // Tags
  projetoTags: state => state.projetoTags,
  // Projetos Vinculo
  projetosVinculo: state => state.projetosVinculo,
}

const actions = {
  // Projeto
  resetProjetoState ({ commit }) {
    commit('resetProjetoState');
  },
  async fetchProjetos({ commit }) {
    const response = await axios.get(`http://nuvem.syclus.com.br:5000/api/syclus/sistema/sql/19`);
    if (response.data.Sql) {
      commit('setProjetos', response.data.Sql);
    } else {
      commit('setProjetos', []);
    }
  },
  async fetchProjetosNode({ commit }, args) {
    const response = await axios.get(`${baseUrl}/projetos?idResponsavel=${args.usuario.IdColaborador}&status=${args.status}&idSituacao=${args.idSituacao}`);
    if (response.data.length) {
      commit('setProjetos', response.data);
    } else {
      commit('setProjetos', []);
    }
  },
  async fetchProjetoById({ commit }, { id, idResponsavel }) {
    // const response = await axios.get(`${baseUrl}/projetos/${id}?idResponsavel=${idResponsavel}`);
    const response = await axios.get(`${baseUrl}/projetos/${id}`);

    if (response.data.length) {
      commit('setProjetos', response.data);
      return response.data[0];
    } else {
      commit('setProjetos', []);
    }
  },
  async fetchProjetosParaVinculo({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/projetos?vincular=true&idProjeto=${args.idProjeto}&idResponsavel=${args.idResponsavel}`);
      commit('setProjetos', response.data);
    } catch (error) {
      commit('setProjetos', []);
    }
  },
  async fetchSituacaoProjetos({ commit }, situacao) {
    commit('setSituacaoProjetos', situacao);
  },
  async addProjeto({ commit }, projeto) {
    const response = await axios.post(`${baseUrl}/projetos`, projeto, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    projeto.IdProjeto = response.data.cd_projeto;
    commit('newProjeto', projeto);
    return response.data.IdProjeto;
  },
  async fetchMeusProjetosSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/projetos?idLayoutSql=${args.idLayoutSql}&idResponsavel=${args.usuario.IdColaborador}`);
      if (response.data.length) {
        commit('setProjetos', response.data);
      } else {
        commit('setProjetos', []);
      }
    } catch (error) {
      commit('setProjetos', []);
    }
  },
  async fetchPeriodoProjetosSql({ commit }, args) {
    try {
      const response = await axios.get(`${baseUrl}/projetos?idLayoutSql=${args.idLayoutSql}&idResponsavel=${args.usuario.IdColaborador}&dataInicio=${args.dataInicial}&dataFinal=${args.dataFinal}`);
      if (response.data.length) {
        commit('setProjetos', response.data);
      } else {
        commit('setProjetos', []);
      }
    } catch (error) {
      commit('setProjetos', []);
    }
  },
  async updateProjeto({ commit }, updProjeto) {
    await axios.put(`${baseUrl}/projetos/${updProjeto.IdProjeto}`, updProjeto, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('updateProjeto', updProjeto);
  },
  async finalizarProjetoNode({ commit }, finProjeto) {
    finProjeto.Status = 'F';
    await axios.put(`${baseUrl}/projetos/${finProjeto.IdProjeto}`, finProjeto, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('finalizaProjeto', finProjeto);
  },
  async deleteProjeto({ commit }, id) {
    const response = await axios.delete(`${baseUrl}/projetos/${id}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeProjeto', id);
  },
  async duplicaProjeto({}, obj) {
    await axios.post(`${baseUrl}/duplicaprojeto`, obj, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
  },
  // Colaboradores
  async fetchProjetoColaboradores({ commit }, id) {
    const response = await axios.get(`${baseUrl}/projetoscolaboradores/${id}`);
    if (response.data.length) {
      commit('setProjetoColaboradores', response.data);
    } else {
      commit('setProjetoColaboradores', []);
    }
  },
  async addProjetoColaborador({ commit }, colaborador) {
    try {
      // const response = await axios.post(`${baseUrl}/projetoscolaboradores`, colaborador);
      const response = await projetoService.addProjetoColaborador(colaborador);
      commit('newProjetoColaborador', colaborador);
      store.commit('showNotification', { text: 'Operação concluída com sucesso.', status: 'success' });
      return response;
    } catch (error) {
      store.commit('showNotification', { text: error.response.data.error, status: 'error' });
      return error.response;
    }
  },
  async deleteProjetoColaborador({ commit }, colaborador) {
    await axios.delete(`${baseUrl}/projetoscolaboradores/${colaborador.IdProjeto}/${colaborador.IdColaborador}`, {
      headers: {
        "Content-Type": "application/json",
        "Access-Control-Allow-Origin": "*"
      }
    });
    commit('removeProjetoColaborador', colaborador.IdColaborador);
  },
  // Projetos Selected
  async selectProjetos({ commit }, projetos) {
    commit('newProjetoSelected', projetos);
  },
  async resetProjetosSelected({ commit }) {
    commit('resetProjetosSelected');
  },
  // Tags
  async fetchProjetoTags({ commit }, id) {
    const response = await axios.get(`${baseUrl}/projetostags/${id}`);
    if (response.data.length) {
      commit('setProjetoTags', response.data);
    } else {
      commit('setProjetoTags', []);
    }
  },
  async addProjetoTag({ commit }, tag) {
    try {
      // const response = await axios.post(`${baseUrl}/projetostags`, tag);
      const response = await projetoService.addProjetoTag(tag);
      commit('newProjetoTag', tag);
      store.commit('showNotification', { text: 'Operação concluída com sucesso.', status: 'success' });
      return response;
    } catch (error) {
      store.commit('showNotification', { text: error.response.data.error, status: 'error' });
      return error.response;
    }
  },
  async deleteProjetoTag({ commit }, tag) {
    await axios.delete(`${baseUrl}/projetostags/${tag.IdProjeto}/${tag.IdTag}`);
    commit('removeProjetoTag', tag.IdTag);
  },
  // Itens Projetos
  async fetchItensProjetosNode({ commit }, idProjeto) {
    const response = await axios.get(`${baseUrl}/itensprojetos/${idProjeto}`);
    if (response.data.length) {
      commit('setItensProjetos', response.data);
    } else {
      commit('setItensProjetos', []);
    }
  },
  async addItemProjeto({ commit }, itemProjeto) {
    const response = await axios.post(`${baseUrl}/itensprojetos`, itemProjeto);
    itemProjeto.IdItem = response.data.IdItem;
    commit('newItemProjeto', itemProjeto);
    return itemProjeto;
  },
  async updateItemProjeto({ commit }, updItemProjeto) {
    await axios.put(`${baseUrl}/itensprojetos/${updItemProjeto.IdProjeto}/${updItemProjeto.IdItem}`, updItemProjeto);
    commit('updateItemProjeto', updItemProjeto);
  },
  async deleteItemProjeto({ commit }, itemProjeto) {
    if (itemProjeto.Atividade) {
      let idAtividade = itemProjeto.Atividade.IdAtividade;
      await axios.delete(`${baseUrl}/itensprojetos/${itemProjeto.IdProjeto}/${itemProjeto.IdItem}?idAtividade=${idAtividade}`);
    } else if (itemProjeto.Projeto) {
      let idProjetoVinculo = itemProjeto.Projeto.IdProjeto;
      await axios.delete(`${baseUrl}/itensprojetos/${itemProjeto.IdProjeto}/${itemProjeto.IdItem}?idProjetoVinculo=${idProjetoVinculo}`);
    } else {
      await axios.delete(`${baseUrl}/itensprojetos/${itemProjeto.IdProjeto}/${itemProjeto.IdItem}`);
    }
    commit('removeItemProjeto', itemProjeto.IdItem);
  },
  // Atividades Projeto
  async fetchAtividadesProjetoTodas({ commit }, idProjeto) {
    const response = await axios.get(`${baseUrl}/atividades?idProjeto=${idProjeto}&todas=true&vinculadas=false`);
    if (response.data.length) {
      commit('setAtividadesProjeto', response.data);
    } else {
      commit('setAtividadesProjeto', []);
    }
  },
  async fetchAtividadesProjeto({ commit }, idProjeto) {
    const response = await axios.get(`${baseUrl}/atividades?idProjeto=${idProjeto}&todas=false&vinculadas=false`);
    if (response.data.length) {
      commit('setAtividadesProjeto', response.data);
    } else {
      commit('setAtividadesProjeto', []);
    }
  },
  async fetchAtividadesVinculadasProjeto({ commit }, idProjeto) {
    const response = await axios.get(`${baseUrl}/atividades?idProjeto=${idProjeto}&vinculadas=true`);
    if (response.data.length) {
      commit('setAtividadesProjeto', response.data);
    } else {
      commit('setAtividadesProjeto', []);
    }
  },
  // Projetos Projeto
  async fetchProjetosVinculo({ commit }, idProjeto) {
    const response = await axios.get(`${baseUrl}/projetosvinculos/${idProjeto}`);
    if (response.data.length) {
      commit('setProjetosVinculo', response.data);
    } else {
      commit('setProjetosVinculo', []);
    }
  },
}

const mutations = {
  // Projeto
  resetProjetoState: state => Object.assign(state, getDefaultState()),
  setProjetos: (state, projetos) => state.projetos = projetos,
  newProjetoSelected: (state, projetos) => state.projetosSelected = projetos,
  setSituacaoProjetos: (state, situacao) => state.projetos = state.projetos.filter(projeto => projeto.IdSituacao == situacao.id),
  newProjeto: (state, projeto) => state.projetos.push(projeto),
  removeProjeto: (state, id) => state.projetos = state.projetos.filter(projeto => projeto.IdProjeto !== id),
  updateProjeto: (state, updProjeto) => {
    const index = state.projetos.findIndex(projeto => projeto.IdProjeto === updProjeto.IdProjeto);
    if (index !== -1) {
      state.projetos.splice(index, 1, updProjeto);
    }
  },
  finalizaProjeto: (state, finProjeto) => {
    const index = state.projetos.findIndex(projeto => projeto.IdProjeto === finProjeto.IdProjeto);
    if (index !== -1) {
      state.projetos.splice(index, 1, finProjeto);
    }
  },
  resetProjetosSelected: state => state.projetosSelected = [],
  // Colaboradores
  setProjetoColaboradores: (state, projetoColaboradores) => state.projetoColaboradores = projetoColaboradores,
  newProjetoColaborador: (state, colaborador) => state.projetoColaboradores.push(colaborador),
  removeProjetoColaborador: (state, id) => state.projetoColaboradores = state.projetoColaboradores.filter(colaborador => colaborador.IdColaborador !== id),
  // Tags
  setProjetoTags: (state, tags) => state.projetoTags = tags,
  newProjetoTag: (state, tag) => state.projetoTags.push(tag),
  removeProjetoTag: (state, id) => state.projetoTags = state.projetoTags.filter(tag => tag.IdTag !== id),
  // Itens Projeto
  setItensProjetos: (state, itensProjetos) => state.itensProjetos = itensProjetos,
  newItemProjeto: (state, itemProjeto) => state.itensProjetos.push(itemProjeto),
  removeItemProjeto: (state, id) => state.itensProjetos = state.itensProjetos.filter(itemProjeto => itemProjeto.IdItem !== id),
  updateItemProjeto: (state, updItemProjeto) => {
    const index = state.itensProjetos.findIndex(itemProjeto => itemProjeto.IdItem === updItemProjeto.IdItem);
    if (index !== -1) {
      state.itensProjetos.splice(index, 1, updItemProjeto);
    }
  },
  // Atividades Projeto
  setAtividadesProjeto: (state, atividadesProjetos) => state.atividadesProjeto = atividadesProjetos,
  // Projetos Vinculo
  setProjetosVinculo: (state, projetosVinculo) => state.projetosVinculo = projetosVinculo,
}

export default {
  state,
  getters,
  actions,
  mutations
}